export const SEQUENCE_NAVIGATE = 'SEQUENCE_NAVIGATE';
export const RECIPIENT_NAVIGATE = 'RECIPIENT_NAVIGATE';
export const EMAIL_GET = 'EMAIL_GET';
export const RECIPIENTS_GET = 'RECIPIENTS_GET';
export const RECIPIENTS_SORT = 'RECIPIENTS_SORT';
